module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dialog"
  }, [_c('mu-appbar', {
    attrs: {
      "title": _vm.userData.self.name,
      "zDepth": 0
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "slot": "left",
      "icon": "arrow_back"
    },
    on: {
      "click": _vm.showDialog_x
    },
    slot: "left"
  }), _vm._v(" "), _c('div', {
    staticClass: "right-top",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('mu-icon-button', {
    attrs: {
      "icon": "videocam"
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "icon": "call"
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "icon": "person"
    },
    on: {
      "click": _vm.showPersonindex_x
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "patch-1"
  }), _vm._v(" "), _c('my-dialogue', {
    staticClass: "dialogue",
    attrs: {
      "userData": _vm.userData
    },
    on: {
      "scrollC": _vm.scrollC
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "patch-2"
  }), _vm._v(" "), _c('a', {
    ref: "end",
    staticStyle: {
      "height": "0",
      "color": "rgba(0,0,0,0)"
    },
    attrs: {
      "name": "1",
      "href": "#1"
    }
  }, [_vm._v(".")])], 1), _vm._v(" "), _c('div', {
    ref: "footer",
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('mu-text-field', {
    attrs: {
      "hintText": "请输入文字"
    },
    on: {
      "focus": _vm.focus,
      "blur": _vm.blur
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.sendValue.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "icon": "send"
    },
    on: {
      "click": _vm.sendValue
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('mu-icon-button', {
    attrs: {
      "icon": "mic_none"
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "icon": "photo_size_select_actual"
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "icon": "tag_faces"
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "icon": "switch_video"
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "icon": "cloud_queue"
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "icon": "photo_camera"
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    attrs: {
      "icon": "folder_open"
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-321245e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/dialog.vue
// module id = 501
// module chunks = 1